/**
 * Shared display labels — single source of truth so we never leak raw enum
 * values like "quote_sent" into the UI.
 */

export const STATUS_LABELS: Record<string, string> = {
  received: "Anfrage eingegangen",
  in_review: "In Bearbeitung",
  inspection_scheduled: "Besichtigungstermin",
  inspection_done: "Besichtigung abgeschlossen",
  quote_sent: "Angebot gesendet",
  quote_declined: "Angebot abgelehnt",
  quote_approved: "Angebot freigegeben",
  scheduled: "Auftrag eingeplant",
  in_progress: "In Arbeit",
  completed: "Abgeschlossen",
  invoiced: "Rechnung gesendet",
  paid: "Bezahlt",
  cancelled: "Abgesagt",
};

export const STATUSES = Object.keys(STATUS_LABELS);

export function statusLabel(s: string | null | undefined): string {
  if (!s) return "—";
  return STATUS_LABELS[s] ?? s.replace(/_/g, " ");
}

export const URGENCY_LABELS: Record<string, string> = {
  notfall: "Notfall",
  bald: "Bald",
  planen: "Flexibel",
};

export function urgencyLabel(u: string | null | undefined): string {
  if (!u) return "";
  return URGENCY_LABELS[u] ?? u;
}

export const ROLE_LABELS: Record<string, string> = {
  superadmin: "Superadmin",
  admin: "Geschäftsführer",
  staff: "Bürokraft",
};

export const DOC_LABELS: Record<string, string> = {
  angebot: "Angebot",
  arbeitsbericht: "Arbeitsbericht",
  rechnung: "Rechnung",
};

export const EVENT_LABELS: Record<string, string> = {
  status_change: "Status geändert",
  note: "Notiz hinzugefügt",
  email_sent: "E-Mail gesendet",
  document_uploaded: "Dokument hochgeladen",
  quote_approved: "Angebot vom Kunden freigegeben",
  customer_message: "Nachricht vom Kunden",
};

export function eventLabel(t: string | null | undefined): string {
  if (!t) return "";
  return EVENT_LABELS[t] ?? t.replace(/_/g, " ");
}
